export const API_URL="https://afdprojipactst7000.azurefd.net";
export const SSO_URL = "https://apis-tst.groupe-atlantic.com:443";
export const ENV="release";
export const VERSION="0.0.1";
export const LOGOUT_REDIRECT_URL="wso2creator_ATL_Projipac4_Test_PRODUCTION";
export const MANIFEST_NAME="manifest"
